<template>
   <div>
     <!--<i-header></i-header>-->
     <div class="swiper-container">
       <div class="swiper-wrapper">
       <swiper :options="swiperOption" ref="mySwiper">
         <!-- 幻灯内容 -->
         <swiper-slide><img src="./Home/img/1.jpg" style="height:100%"/></swiper-slide>
         <swiper-slide><img src="./Home/img/2.jpg" style="height:100%"/></swiper-slide>
         <swiper-slide><img src="./Home/img/3.jpg" style="height:100%"/></swiper-slide>
         <swiper-slide><img src="./Home/img/4.jpg" style="height:100%"/></swiper-slide>
         <!-- 以下控件元素均为可选 -->
         <div class="swiper-pagination" slot="pagination"></div>
       </swiper>
     </div>
     </div>
   </div>
</template>

<script type="text/ecmascript-6">

  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  // import iHeader from './Home/Header/Header.vue'

  export default {
    data () {
      return {
        data: {},
        swiperOption: {
          // 所有配置均为可选（同Swiper配置）
          initialSlide: 0,
          // pagination:'.swiper-pagination',
          pagination: {
            el: '.swiper-pagination',
            clickable:true
          },
          loop: true,
          speed: 200,
          direction: 'horizontal',
          paginationClickable: true,
          mousewheelControl: true,
          autoplay:{
            stopOnLastSlide:true,
            disableOnInteraction: false,
          },
          //autoplay: true,
          autoplayDisableOnInteraction: false,
          observer: true,
          observeParents: true,
          debugger: true,
          onTransitionStart (swiper) {
            console.log(swiper)
          }
        }
      }
    },
    mounted () {
      // 这边就可以使用swiper这个对象去使用swiper官网中的那些方法
      //this.swiper.slideTo(1, 1000, false)
    },
    computed: {
      // swiper () {
      //   return this.$refs.mySwiper.swiper
      // }
    },
    components: {
      swiper,
      swiperSlide,
      // iHeader
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>
  .swiper-container {
    width: 800px;
    height: 400px;
    .swiper-wrapper {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      background-position: center;
      background-size: cover;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue